import { render, staticRenderFns } from "./rewardExchangeStoreEdit.vue?vue&type=template&id=2bba8fc2&scoped=true&"
import script from "./rewardExchangeStoreEdit.vue?vue&type=script&lang=js&"
export * from "./rewardExchangeStoreEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba8fc2",
  null
  
)

export default component.exports